import { render, staticRenderFns } from "./SecretComponent.vue?vue&type=template&id=ec90e304&"
import script from "./SecretComponent.vue?vue&type=script&lang=js&"
export * from "./SecretComponent.vue?vue&type=script&lang=js&"
import style0 from "./SecretComponent.vue?vue&type=style&index=0&id=ec90e304&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports